import React, { useEffect } from 'react';
import img from "../../assets/header-banner-image.png";
import img2 from "../../assets/header-banner-1.png";
import "./header.css";
import { FaCheckCircle } from 'react-icons/fa';
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";

function Header() {

  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  const handleclick = () => {
    navigate("/aboutus");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleLearn = () => {
    navigate("/service");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <section className="header-section">
        <div className="container header-container d-flex align-items-center justify-content-between">
          
          {/* Left side text */}
          <div className="header-text" data-aos="fade-right">
            <h3>Transform Your Vision Into</h3>
            <h2>A Stunning Digital Experience</h2>
            <p>Your website, designed to engage and built to grow. Start your digital journey with us!</p>

            <div className="header-buttons">
              <button className="main-button" onClick={handleclick}>Get Started</button>
              &nbsp;
              <button className="main-button-1" onClick={handleLearn}>Learn More</button>
            </div>
          </div>

          {/* Right side image */}
          <div className="header-image" data-aos="fade-left">
            <img src={img} alt="Digital Experience" />
          </div>
        </div>
      </section>

      <section className="growth-section">
        <div className="container growth-container d-flex align-items-center justify-content-between">

          {/* Left Side - Image */}
          <div className="growth-image" data-aos="fade-left">
            <img src={img2} alt="Business Growth" />
          </div>

          {/* Right Side - Content */}
          <div className="growth-content" data-aos="fade-right">
            <h5>FOR YOUR BUSINESS GROWTH</h5>
            <h2>Want to go online?<br />We’re here to assist!</h2>
            <p>
              At Redite, we specialize in creating stunning and functional websites
              that are tailored to your business needs. Whether you’re looking for
              a sleek design, advanced features, or an engaging user experience, we’ve got you covered.
            </p>

            <p>We provide the following services across the globe:</p>

            <ul className="growth-list">
              <li><FaCheckCircle style={{ color: "#E00C09", marginRight: "8px" }} /> Logo Design</li>
              <li><FaCheckCircle style={{ color: "#E00C09", marginRight: "8px" }} /> Advertising & Marketing</li>
              <li><FaCheckCircle style={{ color: "#E00C09", marginRight: "8px" }} /> Web Development</li>
              <li><FaCheckCircle style={{ color: "#E00C09", marginRight: "8px" }} /> Mobile App Development</li>
              <li><FaCheckCircle style={{ color: "#E00C09", marginRight: "8px" }} /> Search Engine Optimization</li>
            </ul>

            <button className="main-button" onClick={handleclick}>Explore Further</button>
          </div>
        </div>
      </section>
    </>
  );
}

export default Header;
